<div class="loading-title-prefilled"
     *ngIf="prefilledAi && !(builderInteractionsService.hidePrefilledAnimations | async)"
     [class.deactivate]="(_triggerService.startSidebarAnimations|async)"
     [class.active]="builderInteractionsService.enhancedDescriptionIsDone.value">{{ 'text_buildingACleanDetailedStructureForYourWebsite' | dbText }}</div>
<db-draggable-canvas (canvasScale)="scaleInPercentage = $event"
                     [scaleLevel]="scaleInPercentage"
                     [prefilledAi]="prefilledAi"
                     [isMobile]="isMobile"
                     [disableDraggingEvents]="disableDraggingEvents"
                     [isSmoothTransition]="isSmoothTransition"
                     (smoothTransition)="isSmoothTransition = $event">
  <section class="builder-outline"
           [class.with-animation]="prefilledAi"
           [class.active]="builderInteractionsService.enhancedDescriptionIsDone.value"
           #projected>
    <div class="sceleton"
         [class.with-animation]="prefilledAi"
         [class.active]="builderInteractionsService.enhancedDescriptionIsDone.value">
      <db-builder-header (switchCustomization)="showCustomization = !showCustomization"
                         [popupMode]="popupMode"
                         [user]="user"
                         [website]="website"
                         (onGenerate)="onGenerate.emit()"
                         [showCover]="[tourEnum.CUSTOMIZER, tourEnum.GENERATION].includes(tourStep)"
                         [style.z-index]="[tourEnum.CUSTOMIZER, tourEnum.GENERATION].includes(tourStep) ? accentZIndex : 11">
      </db-builder-header>
      <db-builder-canvas
        [class.with-animation]="prefilledAi"
        (canvasScale)="scaleInPercentage = $event"
        [scale]="scaleInPercentage"
        [singlePage]="singlePage"
        [user]="user"
        (openMagicLink)="openMagicLink.emit($event)"
        [uniqueId]="uniqueId"
        [website]="website"
        [pageMeta]="outline?.pages_meta"
        [popupMode]="popupMode"
        [style.z-index]="tourEnum.PAGE_BUILDER === tourStep ? accentZIndex : 10">
      </db-builder-canvas>
      <div class="floating-buttons {{showCustomization}}"
           [class.with-animation]="prefilledAi || _prepareDialogWasTriggered"
           [class.active]="(startAnimations$|async) && _prepareDialogWasTriggered"
           [class.popupMode]="popupMode"
           *ngIf="!isMobile"
           dbStopPinchEvent
           [class.side]="showCustomization || tourEnum.CUSTOMIZER === tourStep">
        <db-zoom-fit></db-zoom-fit>
        <db-zoom-controller
          [minZoomLevel]="canvasZoomService.minZoom|async"
          [maxZoomLevel]="canvasZoomService.maxZoom|async"
          [(zoomLevel)]="scaleInPercentage">
        </db-zoom-controller>
      </div>
        <div class="mouse-navigation-label"
             [class.with-animation]="prefilledAi"
             [class.active]="(startAnimations$|async)"
             [class.popupMode]="popupMode"
             *ngIf="!isMobile && !singlePage">
            <i class="db-icon db-icon-ds-mouse-border"></i><span [innerHTML]="'text_spacebarLeftclickToMoveAround' | dbText"></span>
        </div>
    </div>
    <div class="cover"
         *ngIf="coverSteps.includes(tourStep) || (builderInteractionsService.buildLoading|async)">
    </div>
  </section>
</db-draggable-canvas>
